export default __webpack_public_path__ + "static/media/upload_member_data.434821e5.svg";